import React from 'react'
import logo from '../../../assets/static/logo-rota10.png'

const LogotipoRota = () => (
	<img className="logotipo-rota" src={logo} alt="Logotipo Rota 10" />
)

export default LogotipoRota
